import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { levelPath, volumes } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Volumes() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-236" data-mp="184ey7rx3ey2q">
      <div className="mx-auto max-w-6xl" data-id="element-237" data-mp="181sk19fp5kbj">
        <Eyebrow data-id="element-238" data-mp="1c4yu6s5xjvna">What's inside the system</Eyebrow>
        <SectionTitle data-id="element-239" data-mp="1c3e2dab02qt4">
          5 volumes. <Mark data-id="element-240" data-mp="1zvb428kqk2gi">Major joints and movement regions covered.</Mark>
        </SectionTitle>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-6" data-id="element-241" data-mp="24u5spr5dwl8j">
          {volumes.map((volume, index) => <li key={volume.number} className={`flex flex-col rounded-2xl border border-navy/10 bg-canvas p-5 ${index < 3 ? 'lg:col-span-2' : 'lg:col-span-3'}`} data-id="element-242" data-mp="1quwgt3o7odad" data-mpi={index}>
              <span className="self-start rounded-md bg-brand px-2 py-0.5 font-display text-[10px] font-black uppercase tracking-wider text-white" data-id="element-243" data-mp="feycfd3zaffh">
                Volume {volume.number}
              </span>
              <h3 className="mt-2 font-display text-sm font-black uppercase leading-tight text-navy" data-id="element-244" data-mp="3o7dg1c9dp4qz">{volume.name}</h3>
              <p className="mt-1.5 text-[10px] font-bold uppercase leading-snug tracking-wide text-brand" data-id="element-245" data-mp="3jadf1frdys6q">
                {volume.focus}
              </p>
              <p className="mt-1.5 text-xs leading-snug text-steel" data-id="element-246" data-mp="3t7j82tjk8t9l">{volume.text}</p>
            </li>)}
        </ul>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-247" data-mp="b0ldribai2za">
          {levelPath.map((level, index) => <React.Fragment key={level} data-id="element-248" data-mp="62a4b8owpuhl" data-mpi={index}>
              {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-249" data-mp="krzm8fl7yd4k" />}
              <span className="rounded-full bg-navy px-3 py-1.5 font-display text-[10px] font-black uppercase tracking-wider text-white" data-id="element-250" data-mp="fsmzrvy9f82i">
                {level}
              </span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}